import React, { memo, useCallback } from 'react'

import Select from '../../../../Mantine/Select'

import * as S from './styles'

const SelectFilter = ({
  nome,
  localFilters,
  setLocalFilters,
  opcoes,
  isTwoSelect,
  isLoading = false
}) => {
  const handleChange = useCallback(
    (value, campo) => {
      setLocalFilters((prev) => ({
        ...prev,
        [isTwoSelect ? campo : nome]: value
      }))
    },
    [isTwoSelect, setLocalFilters, nome]
  )

  if (isTwoSelect) {
    const [first, second] = nome.split('_')

    return (
      <S.SelectWrapper>
        <Select
          placeholder="Selecione"
          value={localFilters[first]}
          options={opcoes[first] || []}
          onChange={(selected) => handleChange(selected, first)}
          isLoading={isLoading}
        />
        <Select
          placeholder="Selecione"
          value={localFilters[second]}
          options={opcoes[second] || []}
          onChange={(selected) => handleChange(selected, second)}
          isLoading={isLoading}
        />
      </S.SelectWrapper>
    )
  }

  return (
    <Select
      placeholder="Selecione"
      value={localFilters[nome]}
      options={opcoes[nome] || []}
      onChange={(selected) => handleChange(selected)}
      isLoading={isLoading}
    />
  )
}

export default memo(SelectFilter)
